// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + ({"112":"dashjs","366":"panolens","490":"webvtt","602":"hlsjs","721":"vttjs"}[chunkId] || chunkId) + "." + {"112":"f3515233","193":"c9bec5ee","366":"bf60d469","490":"7076334d","602":"88ebda08","683":"649f3c1e","721":"2ceb99d6","755":"150db292","967":"0edc8593"}[chunkId] + ".chunk.js";
};